"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const Sentry = tslib_1.__importStar(require("@sentry/react"));
const react_router_dom_1 = require("react-router-dom");
const MainProvider_1 = require("src/providers/MainProvider");
const client_1 = require("react-dom/client");
const react_1 = require("react");
const App_1 = tslib_1.__importDefault(require("./App"));
const TranslationProvider_1 = tslib_1.__importDefault(require("src/providers/TranslationProvider"));
if (process.env.SENTRY_DSN) {
    Sentry.init({
        dsn: process.env.SENTRY_DSN,
        environment: process.env.NODE_ENV,
        replaysSessionSampleRate: 0.1,
        replaysOnErrorSampleRate: 1.0,
        integrations: [
            Sentry.reactRouterV6BrowserTracingIntegration({
                useEffect: react_1.useEffect,
                useLocation: react_router_dom_1.useLocation,
                useNavigationType: react_router_dom_1.useNavigationType,
                createRoutesFromChildren: react_router_dom_1.createRoutesFromChildren,
                matchRoutes: react_router_dom_1.matchRoutes
            }),
            Sentry.replayIntegration()
        ]
    });
}
const createElement = document.createElement('div');
createElement.className = 'd-flex flex-column flex-root';
createElement.id = 'app';
document.body.appendChild(createElement);
document.body.className =
    'header-fixed' +
        ' header-mobile-fixed' +
        ' subheader-enabled' +
        ' subheader-fixed' +
        ' aside-enabled' +
        ' aside-fixed' +
        ' aside-minimize-hoverable';
const domNode = document.getElementById('app');
const root = (0, client_1.createRoot)(domNode);
root.render((0, jsx_runtime_1.jsx)(react_router_dom_1.BrowserRouter, { children: (0, jsx_runtime_1.jsx)(MainProvider_1.MainProvider, { children: (0, jsx_runtime_1.jsx)(TranslationProvider_1.default, { children: (0, jsx_runtime_1.jsx)(App_1.default, {}) }) }) }));
